/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guidevideo_Empty_Manage1Inputs */

const vi_guidevideo_empty_manage1 = /** @type {(inputs: Guidevideo_Empty_Manage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có video nào. Bấm "Thêm video" để chọn video trong Thư viện ảnh hoặc tải lên.`)
};

/**

* @param {Guidevideo_Empty_Manage1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const guidevideo_empty_manage1 = /** @type {((inputs?: Guidevideo_Empty_Manage1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guidevideo_Empty_Manage1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_guidevideo_empty_manage1(inputs)
});
export { guidevideo_empty_manage1 as "guideVideo_empty_manage" }